/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Mission_TextInputs */

const en_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Making AI-powered career tools accessible to every European job seeker. We believe that great career tools should not require you to sacrifice your privacy or hand over your data to US cloud providers.`)
};

const de_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-gestuetzte Karriere-Tools fuer jeden europaeischen Jobsuchenden zugaenglich machen. Wir glauben, dass grossartige Karriere-Tools nicht erfordern sollten, dass du deine Privatsphaere opferst oder deine Daten an US-Cloud-Anbieter uebergibst.`)
};

const fr_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendre les outils de carrière alimentés par l'IA accessibles à chaque chercheur d'emploi européen. Nous croyons que la technologie doit aider, pas remplacer.`)
};

const es_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacemos accesibles las herramientas de carrera impulsadas por IA para todos los buscadores de empleo europeos. Creemos que las buenas herramientas de carrera no deben ser exclusivas.`)
};

const it_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendiamo accessibili gli strumenti di carriera basati sull'IA a ogni persona in cerca di lavoro in Europa. Crediamo che i buoni strumenti di carriera non debbano essere un privilegio di pochi.`)
};

const nl_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wij maken AI-aangedreven carrièretools toegankelijk voor iedere Europese werkzoekende. Wij geloven dat goede carrièretools niet voorbehouden mogen zijn aan enkelen.`)
};

const pl_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udostepniamy narzedzia kariery oparte na AI kazdemu europejskiemu poszukiwaczowi pracy. Wierzymy, ze dobre narzedzia kariery nie powinny byc przywilejem nielicznych.`)
};

const fi_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teemme AI-pohjaisista uratyökaluista saavutettavia kaikille eurooppalaisille työnhakijoille. Uskomme, ettei hyvien uratyökalujen pitäisi olla harvojen etuoikeus.`)
};

const da_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi gor AI-drevne karrierevaerktajer tilgaengelige for alle europaeiske jobsogere. Vi tror pa, at gode karrierevaerktajer ikke bor vaere forbeholdt de fa.`)
};

const sv_about_mission_text = /** @type {(inputs: About_Mission_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi gor AI-drivna karriarverktyg tillgangliga for alla europeiska jobbsokare. Vi tror att bra karriarverktyg inte bor vara forbehallna fa.`)
};

/**
* | output |
* | --- |
* | "Making AI-powered career tools accessible to every European job seeker. We believe that great career tools should not require you to sacrifice your privacy o..." |
*
* @param {About_Mission_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_mission_text = /** @type {((inputs?: About_Mission_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Mission_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_mission_text(inputs)
	if (locale === "fr") return fr_about_mission_text(inputs)
	if (locale === "es") return es_about_mission_text(inputs)
	if (locale === "it") return it_about_mission_text(inputs)
	if (locale === "nl") return nl_about_mission_text(inputs)
	if (locale === "pl") return pl_about_mission_text(inputs)
	if (locale === "fi") return fi_about_mission_text(inputs)
	if (locale === "da") return da_about_mission_text(inputs)
	if (locale === "sv") return sv_about_mission_text(inputs)
	return en_about_mission_text(inputs)
});